import axios, { AxiosError } from 'axios';
import { JSX } from 'react';
import i18n from 'translations/i18n';
import rg4js from 'raygun4js';
import messageBroker from 'utils/services/messageBroker';

export type ApiError<T = any> = AxiosError<T> & {
    message: JSX.Element;
};

export const isApiError = (error: Error): error is ApiError => {
    return error.name === 'ApiError';
};

export const heliosAPI = axios.create();
heliosAPI.interceptors?.response.use(
    (config) => config,
    (error) => {
        let message: string = '';
        if (error.response?.status === 403) {
            message = i18n.t('common:errors.permissions_error');
        } else if ([400, 422].includes(error.response?.status)) {
            message = i18n.t('common:errors:invalid_request_error');
        } else if (error.response || error.request) {
            message = i18n.t('common:errors:network_error');
        } else {
            message = i18n.t('common:errors:unknown_error');
        }

        if (error.response?.status === 401) {
            message = i18n.t('common:errors.access_error');

            messageBroker.publish({ type: 'unauthorizedError' });
        }

        if (error.response?.status >= 500) {
            const raygunMessage = `API Error ${error.response?.status} - ${error.response?.data?.detail}`;
            rg4js('send', {
                error,
                customData: [{ description: raygunMessage }],
            });
        } else if (error?.code === 'ERR_NETWORK') {
            rg4js('send', {
                error,
                customData: [{ description: 'Network error' }],
            });
        }

        return Promise.reject({ ...error, message, name: 'ApiError' });
    }
);
